module.exports = __webpack_public_path__ + "img/icon16.12b092cf.png";